/**
 * 사업자등록번호 유효성 검사 결과
 */
export interface BusinessRegNumberValidation {
  isValid: boolean;
  error?: string;
}

/**
 * 사업자등록번호 포맷팅 (3-2-5)
 * @param input - 입력된 문자열
 * @returns 포맷팅된 사업자등록번호. 10자리 초과할 경우 원본 문자열 반환
 */
export const formatBusinessRegNumber = (input: string): string => {
  // 숫자만 추출
  const numbers = input.replace(/\D/g, '');

  if (numbers.length > 10) {
    return numbers;
  }

  // 3-2-5 패턴으로 포맷팅
  if (numbers.length > 5) {
    return numbers.replace(/^(\d{3})(\d{2})(\d{1,5}).*$/, '$1-$2-$3');
  }
  if (numbers.length > 3) {
    return numbers.replace(/^(\d{3})(\d{1,2}).*$/, '$1-$2');
  }
  return numbers;
};

/**
 * 사업자등록번호에서 숫자만 추출
 * @param input - 포맷팅된 사업자등록번호
 * @returns 숫자만 포함된 문자열
 */
export const deformatBusinessRegNumber = (input: string): string => {
  return input.replace(/\D/g, '');
};

/**
 * 사업자등록번호 유효성 검사
 * - 10자리 길이 확인
 * - 법인사업자(영리) 여부 확인 (4~5번째 자리가 81, 84, 85, 86, 87, 88)
 *
 * @param value - 사업자등록번호 (10자리 숫자 문자열)
 * @returns 유효성 검사 결과
 *
 * @example
 * validateBusinessRegNumber('1234567890') // { isValid: false, error: '영리 법인사업자만 등록할 수 있습니다' }
 * validateBusinessRegNumber('1238112345') // { isValid: true }
 */
export const validateBusinessRegNumber = (value: string): BusinessRegNumberValidation => {
  const numbers = deformatBusinessRegNumber(value);

  if (numbers.length === 0) {
    return { isValid: false, error: '' };
  }

  if (numbers.length < 10) {
    return { isValid: false, error: '10자리를 모두 입력해주세요' };
  }

  // 법인사업자 체크 (4~5번째 자리가 81, 84, 85, 86, 87, 88인지 확인)
  const nn = numbers.slice(3, 5);
  if (!['81', '84', '85', '86', '87', '88'].includes(nn)) {
    return { isValid: false, error: '영리 법인사업자만 등록할 수 있습니다' };
  }

  return { isValid: true };
};
